const COOLDOWN_KEY = 'sp-preload-reload-at'
const COOLDOWN_MS = 60_000

// Vite fingerprints chunk filenames, so a deployment that removes old chunks
// causes stale tabs' React.lazy() imports to 404. Reload once to pick up the
// new chunk hashes; the cooldown avoids a reload loop on a genuine network failure.
export const registerPreloadErrorReload = (): void => {
  globalThis.addEventListener('vite:preloadError', (event) => {
    event.preventDefault()

    const lastReload = Number(sessionStorage.getItem(COOLDOWN_KEY) || 0)
    if (Date.now() - lastReload > COOLDOWN_MS) {
      sessionStorage.setItem(COOLDOWN_KEY, String(Date.now()))
      globalThis.location.reload()
    }
  })
}
